import {
  type ChangeEvent,
  type Dispatch,
  type SetStateAction,
  useState,
} from "react";

type InputTypes = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

type TUseFormFields<T> = {
  formFields: T;
  createChangeHandler: (key: keyof T) => (e: ChangeEvent<InputTypes>) => void;
  resetFormFields: () => void;
  setFormFields: Dispatch<SetStateAction<T>>;
};

export function useFormFields<T>(initialValues: T): TUseFormFields<T> {
  const [formFields, setFormFields] = useState<T>(initialValues);

  const createChangeHandler =
    (key: keyof T) => (e: ChangeEvent<InputTypes>) => {
      const target = e.target as InputTypes;
      const { value, type } = target;

      setFormFields((prev) => ({
        ...prev,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key]: type === "checkbox" ? (target as any).checked : value,
      }));
    };

  const resetFormFields = () => {
    setFormFields(() => initialValues);
  };

  return { formFields, setFormFields, createChangeHandler, resetFormFields };
}
